import type { IdentifyResult } from '../types';
import { REASON_LABEL } from './labels';

export function identifyErrorMessage(r: Extract<IdentifyResult, { ok: false }>): string {
  switch (r.error) {
    case 'invalid_credentials':
      return r.attempts_left !== undefined && r.attempts_left > 0
        ? `CI o PIN incorrecto. Le quedan ${r.attempts_left} intento(s).`
        : 'CI o PIN incorrecto.';
    case 'ci_locked':
      return 'Su CI está bloqueado por varios intentos fallidos. Acérquese a la mesa de registro.';
    case 'room_token_invalid':
      return 'El código QR venció. Escanee de nuevo el código de la pantalla.';
    case 'election_closed':
      return 'Esta elección ya terminó.';
    case 'voter_not_eligible':
      return REASON_LABEL[r.reason ?? ''] ?? 'Usted no puede votar en esta elección.';
  }
}
